export default __webpack_public_path__ + "static/seemode-27db39392d51310edfcd97c971ccc6b3.mp4";